var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"valore-rule-page"},[_c('div',{staticClass:"title"},[_vm._v("积分规则说明")]),_vm._v(" "),_c('div',{staticClass:"rule-content",domProps:{"innerHTML":_vm._s(_vm.activityRule)}}),_vm._v(" "),_c('div',{staticClass:"bottom-text"},[_vm._v("最终解释权归 VALORE AOE 所有")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79152c75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Valore/Rule.vue
// module id = null
// module chunks = 